import React, { useState, useRef, useLayoutEffect } from 'react';
import ReactDOM from 'react-dom';
import { ArrowDownSvg, TimesSvg } from 'common/ui/themes/disona/icons';
import { SvgWrapper } from 'common/ui/themes/disona/atoms/SvgWrapper';
import { useMountTransition } from 'common/utils/style.util';
import { S } from './style';

const BackgroundPortal = ({ children, isMounted }) => {
  const ref = useRef(null);

  useLayoutEffect(() => {
    const element = document.createElement('div');
    element.setAttribute('id', 'select-background-portal');
    document.body.appendChild(element);
    ref.current = element;
    return () => {
      document.body.removeChild(element);
    };
  }, []);

  return ref.current ? ReactDOM.createPortal(children, ref.current) : null;
};

export const Select = ({ options = [], value, setValue }) => {
  const [open, setOpen] = useState(false);
  const isMounted = useMountTransition(open, 100);

  return (
    <div style={{ width: '100%' }}>
      <S.Select onClick={() => setOpen((v) => !v)}>
        {value.label}
        <SvgWrapper color="white" hoverColor="cyan" width="10px">
          <ArrowDownSvg />
        </SvgWrapper>
      </S.Select>
      {(isMounted || open) && (
        <BackgroundPortal>
          <S.OverflowLayout
            onClick={(e) => {
              e.stopPropagation();
              setOpen(false);
            }}
          />
          <S.SelectMenu
            isMounted={isMounted}
            open={open}
            height={options.length + 40}
          >
            <S.CloseButton
              onClick={(e) => {
                e.stopPropagation();
                setOpen(false);
              }}
            >
              <SvgWrapper color="white" hoverColor="cyan" width="15px">
                <TimesSvg />
              </SvgWrapper>
            </S.CloseButton>
            {options.map((option) => (
              <S.Option
                selected={value.value === option.value}
                onClick={(e) => {
                  e.stopPropagation();
                  setValue(option);
                  setOpen(false);
                }}
              >
                <span>{option.label}</span>
              </S.Option>
            ))}
          </S.SelectMenu>
        </BackgroundPortal>
      )}
    </div>
  );
};
